import * as CryptoJS from 'crypto-js';

export class EncrDecrService {
    constructor() { }

    set_object(key, value) {
        const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(value), key);

        return ciphertext.toString();
    }
    get_object(key, value) {
        const bytes = CryptoJS.AES.decrypt(value, key);
        try {
            return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        } catch (error) {
            return null;
        }
    }

    //The set method is use for encrypt the value.
    set(keys, value) {
        const key = CryptoJS.enc.Utf8.parse(keys);
        const iv = CryptoJS.enc.Utf8.parse(keys);
        const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(value.toString()), key,
            {
                keySize: 128 / 8,
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });

        return encrypted.toString();
    }

    //The get method is use for decrypt the value.
    get(keys, value) {
        const key = CryptoJS.enc.Utf8.parse(keys);
        const iv = CryptoJS.enc.Utf8.parse(keys);
        const decrypted = CryptoJS.AES.decrypt(value, key, {
            keySize: 128 / 8,
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });

        return decrypted.toString(CryptoJS.enc.Utf8);
    }
}
